export default __webpack_public_path__ + "static/media/suction_tube.370177df.png";